import { ModicaTextarea } from "@modica-library/textarea/react";

type Props = {
  label?: string;
  value?: string;
  onChange?: (e: any) => void;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
  className?: string;
};

/** Thin wrapper over @modica-library/textarea (label/value/onChange). */
export function Textarea({ label, value, onChange, placeholder }: Props) {
  return <ModicaTextarea label={label ?? ""} value={value ?? ""} onChange={onChange} placeholder={placeholder} />;
}
